import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as clusterReducer from "containers/ClusterChart/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as setupReducer from "containers/Setup/reducer";

import InteractionGraph from "components/Dataset/InteractionGraph";

class InteractionGraphContainer extends React.PureComponent {
  render() {
    return <InteractionGraph {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateSelected: (selected) => dispatch(clusterReducer.updateSelected(ownProps.id, selected)),
    updateHover: (hover) => dispatch(clusterReducer.updateHover(ownProps.id, hover))
  };
};

const mapStateToProps = (state, ownProps) => {
  const datasetId = ownProps.datasetId
    ? ownProps.datasetId
    : setupReducer.getDatasetFromSetup(state, ownProps.id)
      ? setupReducer.getDatasetFromSetup(state, ownProps.id).id
      : undefined;

  return {
    datasetId: datasetId,
    interactions: homeReducer.getInteractions(state, datasetId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(InteractionGraphContainer);
